import { useState } from 'react';

const BEEHIIV_URL = 'https://beer-after-work.beehiiv.com/subscribe';

const Newsletter = () => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const email = (form.elements.namedItem('email') as HTMLInputElement)?.value;
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address.');
      return;
    }
    setError('');
    setSubmitted(true);
    window.open(`${BEEHIIV_URL}?email=${encodeURIComponent(email)}`, '_blank');
  };

  return (
    <section id="newsletter" className="w-full py-28 relative overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/cb1b16bec85eff4ca0614d6c2ecc44df.jpg)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-[#2b1810]/95 via-[#1a1a1a]/90 to-[#111111]/95" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        {/* Eyebrow with lines */}
        <div className="flex items-center justify-center gap-4 mb-5">
          <div className="flex-1 h-[1px] bg-[#f5a623]/30 max-w-24" />
          <span className="text-[#f5a623] text-xs font-['Roboto'] font-bold tracking-[5px] uppercase whitespace-nowrap">
            The Biscuit Brief
          </span>
          <div className="flex-1 h-[1px] bg-[#f5a623]/30 max-w-24" />
        </div>

        <h2 className="font-['Bebas_Neue'] text-6xl text-white tracking-wider mb-5 leading-none">
          Parts &amp; Pints<br />Newsletter
        </h2>

        <p className="text-[#c4c4c4] text-lg font-['Roboto'] leading-relaxed mb-10 max-w-xl mx-auto">
          Get the <strong className="text-[#f5a623]">'Biscuit Brief'</strong> in your inbox. Every Friday: one tricky fix explained, one beer recommendation, and one community project shoutout.
        </p>

        {/* Perks */}
        <div className="flex flex-wrap justify-center gap-6 mb-10">
          {[
            { icon: 'ri-tools-fill', text: 'One tricky fix explained' },
            { icon: 'ri-goblet-fill', text: 'One beer recommendation' },
            { icon: 'ri-group-fill', text: 'Community project shoutout' },
          ].map((perk) => (
            <div key={perk.text} className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center text-[#f5a623]">
                <i className={`${perk.icon} text-sm`} />
              </div>
              <span className="text-[#b8b8b8] text-sm font-['Roboto'] whitespace-nowrap">{perk.text}</span>
            </div>
          ))}
        </div>

        {/* Form */}
        {!submitted ? (
          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row items-stretch gap-0 max-w-md mx-auto"
          >
            <div className="relative flex-1">
              <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-[#6a6a6a]">
                <i className="ri-mail-line text-base" />
              </div>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                required
                className="w-full h-14 bg-[#1f1f1f] text-white placeholder-[#6a6a6a] text-sm font-['Roboto'] pl-10 pr-4 border border-[#333333] sm:rounded-l-lg sm:rounded-r-none rounded-lg sm:border-r-0 focus:outline-none focus:border-[#f5a623] transition-colors"
              />
            </div>
            <button
              type="submit"
              className="h-14 bg-[#f5a623] hover:bg-[#d4722e] text-white font-['Roboto'] font-bold text-xs tracking-[2px] uppercase px-6 sm:rounded-r-lg sm:rounded-l-none rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Join the Workshop
            </button>
          </form>
        ) : (
          <div className="flex flex-col items-center gap-3 py-4">
            <div className="w-12 h-12 flex items-center justify-center bg-[#f5a623]/10 border border-[#f5a623]/40 rounded-full">
              <i className="ri-check-line text-[#f5a623] text-2xl" />
            </div>
            <p className="text-white font-['Roboto'] font-bold text-lg">You're in the Workshop!</p>
            <p className="text-[#9a9a9a] text-sm font-['Roboto']">First Biscuit Brief lands in your inbox this Friday.</p>
          </div>
        )}

        {error && (
          <p className="text-red-400 text-sm font-['Roboto'] mt-3">{error}</p>
        )}

        {/* Trust Badge */}
        <div className="flex items-center justify-center gap-2 mt-5">
          <div className="w-4 h-4 flex items-center justify-center text-[#6a6a6a]">
            <i className="ri-lock-line text-xs" />
          </div>
          <span className="text-[#6a6a6a] text-xs font-['Roboto']">
            No spam. Just fixes and beer. Unsubscribe anytime.
          </span>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
